module.exports = __webpack_public_path__ + "504beed5b760ea4dc22164d9a2d6b075.pdf";